import * as React from 'react';
import { observer } from 'mobx-react';
import { CSSTransition } from 'react-transition-group'
import * as FocusTrap from "focus-trap-react";
import {modalLoader} from "./ModalLoader";
import {Modal} from "./Modal";
import {ErrorBoundary} from "../ErrorBoundary";

@observer
export class ModalContainer extends React.Component {
  render(){
    return (
        <ErrorBoundary>
          <CSSTransition
              classNames="page"
              timeout={250}
              in={modalLoader.showModal}
          >
            <section>

              {modalLoader.content && <div aria-modal={true}>
                <FocusTrap focusTrapOptions={
                  {
                    allowOutsideClick: false,
                    clickOutsideDeactivates: true,
                    onDeactivate:()=>{ modalLoader.close(); },
                  }
                }>
                  <div>
                    <Modal
                        closeModal={modalLoader.close}
                        title={modalLoader.title}
                    >
                      <ErrorBoundary>
                        <div className="modalContent">{modalLoader.content}</div>
                      </ErrorBoundary>
                    </Modal>
                  </div>
                </FocusTrap>
              </div>
              }
            </section>
          </CSSTransition>
        </ErrorBoundary>
    );
  }
}